import PubSubUtils from '../../utils/pubsub-utils';
import APP_CONSTANTS from '../../constants';

export const publishWorkDeletedEvent = (data: { caseTypeID: string }) => {
  PubSubUtils.publish(APP_CONSTANTS.PUB_SUB_EVENTS.WORK_EVENTS.WORK_DELETED, data);
};

export default {
  publishWorkDeletedEvent
};
